
<template>
  <div>
      <div class="faq-area default-padding bg-gray">
        <div class="container">
            <div class="faq-items">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="faq-content">
                            <div id='crmWebToEntityForm' class='zcwf_lblLeft crmWebToEntityForm' style='background-color: white;color: black;max-width: 600px;'>
                                
                                <div class='zcwf_title' style='max-width: 600px;color: black;'>Contáctanos</div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <h3><div id="msg" v-show="mostrarMensaje" class="text-center mb-4 font-weight-bold">{{mensaje}}</div></h3>
                                    </div>
                                </div>

                                <form class="was-validated" v-show="!mostrarMensaje">
                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                            <label for="inputTextNombre" class="col-sm-2 col-form-label">Nombre</label>
                                        </div>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control" id="inputTextNombre" placeholder="Nombre" v-model="nombre" required>
                                            <div class="invalid-feedback">este campo no puede estar vacio</div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                            <label for="inputTextApellidos" class="col-sm-2 col-form-label">Apellidos</label>
                                        </div>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control" id="inputTextApellidos" placeholder="Apellidos" v-model="apellidos" required>
                                            <div class="invalid-feedback">este campo no puede estar vacio</div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                            <label for="inputTextMovil" class="col-sm-2 col-form-label">Teléfono contacto</label>
                                        </div>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control" id="inputTextMovil" placeholder="Teléfono" v-model="telefono" required>
                                            <div class="invalid-feedback">este campo no puede estar vacio</div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                            <label for="inputEmail" class="col-sm-2 col-form-label">Email</label>
                                        </div>
                                        <div class="col-sm-8">
                                            <input type="email" class="form-control" id="inputEmail" placeholder="Email" v-model="mail" required>
                                            <div class="invalid-feedback">correo invalido</div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                            <label for="inputTextAplicaciones" class="col-sm-2 col-form-label">Cantidad Aplicaciónes</label>
                                        </div>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control" id="inputTextAplicaciones" placeholder="Cantidad Aplicaciónes" v-model="aplicaciones" required>
                                            <div class="invalid-feedback">este campo no puede estar vacio</div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-4">
                                            <label for="inputTextUsuarios" class="col-sm-2 col-form-label">Cantidad Usuarios</label>
                                        </div>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control" id="inputTextUsuarios" placeholder="Cantidad Usuarios" v-model="usuarios" required>
                                            <div class="invalid-feedback">este campo no puede estar vacio</div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <div class="col-sm-2"></div>
                                        <div class="col-sm-8">
                                            <center>
                                                <button 
                                                    type="button"
                                                    class="btn btn-frm-vapp btn-sm float-left mr-2" 
                                                    @click="enviar"
                                                    v-show="!nombre.length<=0 && !apellidos.length<=0 && !telefono.length<=0 && !mail.length<=0 && !aplicaciones.length<=0 && !usuarios.length<=0">
                                                    Enviar
                                                </button>
                                                <button type="button" class="btn btn-frm-vapp btn-sm float-right mr-2" @click="reestablecer">Reestablecer</button>
                                            </center>
                                        </div>
                                        <div class="col-sm-2"></div>
                                    </div>
                                
                                </form>
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>       
    <!-- End Chose Us -->
    <bannerFooter/>
  </div>
</template>

<script>

    import bannerFooter from '../components/BannerFooter'

    import axios from "axios"
    import cons from '@/utils/const'
    export default {
        name: "Contactanos",
        components: {
            bannerFooter
        },
        data () {
            return {
                mostrarMensaje: false,
                mensaje: "",
                nombre: "",
                apellidos: "",
                telefono: "",
                mail: "",
                aplicaciones: "",
                usuarios: "",

            }
        },
        beforeMount() {},
        methods: {
            enviar: function(){

                var url = `${cons.protocol}://${cons.ipServer}/nuevo_cliente_mail/`
                axios({
                    method: "POST", 
                    "url": url,
                    data: {
                        'nombre': this.nombre,
                        'apellidos': this.apellidos,
                        'mail': this.mail,
                        'telefono': this.telefono,
                        'aplicaciones': this.aplicaciones,
                        'usuarios': this.usuarios
                    },
                }).then(result => {
                    const msg = result.data.msg
                    const user = result.data.user
                    const status = result.data.sts

                    if(msg){
                        if(status=='ok'){
                            this.mensaje = "Hola "+user+"! gracias por contactarnos, se ha contactado a un agente para que se comunique contigo, pronto se pondrá en contacto, saludos!"
                        } else{
                            this.mensaje = "Hola "+user+"! lo sentimos, no hemos podido enviar el correo :(, pero nos puedes enviar un correo directo a ventas@vapp.cl! :) y pronto nos pondremos en contacto!"
                        }
                        this.mostrarMensaje = true;
                    }
                    else{
                       this.mostrarMensaje = false;
                    }

                }, error => {
                    this.mensaje = "Hola "+error.response.data.user+"! lo sentimos, no hemos podido enviar el correo :(, pero nos puedes enviar un correo directo a ventas@vapp.cl! :) y pronto nos pondremos en contacto!"
                    this.mostrarMensaje = true;
                    
                })
                .finally(() => {
                    
                });

            },
            reestablecer: function(){
                this.nombre = "";
                this.apellidos = "";
                this.telefono = "";
                this.mail = "";
                this.aplicaciones = "";
                this.usuarios = "";
            }
        }
    };
</script>

<style scope>
.btn-frm-vapp{
    border-color: #29235C;
    color: #29235C;
}
.btn-frm-vapp:hover{
    background-color: #29235C;
    color: #fff;
}


    #crmWebToEntityForm.zcwf_lblLeft {
        width:100%;
        padding: 25px;
        margin: 0 auto;
        box-sizing: border-box;
    }
    #crmWebToEntityForm.zcwf_lblLeft * {
        box-sizing: border-box;
    }
    #crmWebToEntityForm{text-align: left;}
    #crmWebToEntityForm * {
        direction: ltr;
    }
    .zcwf_lblLeft .zcwf_title {
        word-wrap: break-word;
        padding: 0px 6px 10px;
        font-weight: bold;
    }
    .zcwf_lblLeft .zcwf_col_fld input[type=text], .zcwf_lblLeft .zcwf_col_fld textarea {
        width: 60%;
        border: 1px solid #ccc !important;
        resize: vertical;
        border-radius: 2px;
        float: left;
    }
    .zcwf_lblLeft .zcwf_col_lab {
        width: 30%;
        word-break: break-word;
        padding: 0px 6px 0px;
        margin-right: 10px;
        margin-top: 5px;
        float: left;
        min-height: 1px;
    }
    .zcwf_lblLeft .zcwf_col_fld {
        float: left;
        width: 68%;
        padding: 0px 6px 0px;
        position: relative;
        margin-top: 5px;
    }
    .zcwf_lblLeft .zcwf_privacy{padding: 6px;}
    .zcwf_lblLeft .wfrm_fld_dpNn{display: none;}
    .dIB{display: inline-block;}
    .zcwf_lblLeft .zcwf_col_fld_slt {
        width: 60%;
        border: 1px solid #ccc;
        background: #fff;
        border-radius: 4px;
        font-size: 12px;
        float: left;
        resize: vertical;
    }
    .zcwf_lblLeft .zcwf_row:after, .zcwf_lblLeft .zcwf_col_fld:after {
        content: '';
        display: table;
        clear: both;
    }
    .zcwf_lblLeft .zcwf_col_help {
        float: left;
        margin-left: 7px;
        font-size: 12px;
        max-width: 35%;
        word-break: break-word;
    }
    .zcwf_lblLeft .zcwf_help_icon {
        cursor: pointer;
        width: 16px;
        height: 16px;
        display: inline-block;
        background: #fff;
        border: 1px solid #ccc;
        color: #ccc;
        text-align: center;
        font-size: 11px;
        line-height: 16px;
        font-weight: bold;
        border-radius: 50%;
    }
    .zcwf_lblLeft .zcwf_row {margin: 15px 0px;}
    .zcwf_lblLeft .formsubmit {
        margin-right: 5px;
        cursor: pointer;
        color: #333;
        font-size: 12px;
    }
    .zcwf_lblLeft .zcwf_privacy_txt {
        color: rgb(0, 0, 0);
        font-size: 12px;
        font-family: Arial;
        display: inline-block;
        vertical-align: top;
        color: #333;
        padding-top: 2px;
        margin-left: 6px;
    }
    .zcwf_lblLeft .zcwf_button {
        font-size: 12px;
        color: #333;
        border: 1px solid #ccc;
        padding: 3px 9px;
        border-radius: 4px;
        cursor: pointer;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .zcwf_lblLeft .zcwf_tooltip_over{
        position: relative;
    }
    .zcwf_lblLeft .zcwf_tooltip_ctn{
        position: absolute;
        background: #DEDEDE;
        padding: 3px 6px;
        top: 3px;
        border-radius: 4px;word-break: break-all;
        min-width: 50px;
        max-width: 150px;
        color: #333;
    }
    .zcwf_lblLeft .zcwf_ckbox{
        float: left;
    }
    .zcwf_lblLeft .zcwf_file{
        width: 55%;
        box-sizing: border-box;
        float: left;
    }
    .clearB:after{
        content:'';
        display: block;
        clear: both;
    }
    @media all and (max-width: 600px) {
        .zcwf_lblLeft .zcwf_col_lab, .zcwf_lblLeft .zcwf_col_fld {
            width: auto;
            float: none !important;
        }
        .zcwf_lblLeft .zcwf_col_help {width: 40%;}
    }

</style>